import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f1fe1cc90267f932d5b26d63c79eb2ec.jpg"
          alt="Heart Care Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight">
            心不全の早期発見で
            <br />
            <span className="font-semibold">未来の健康を守る</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-12 leading-relaxed max-w-3xl mx-auto">
            心不全の早期発見と慢性管理をサポートする医療連携プロジェクト
          </p>

          <div className="flex flex-col items-center justify-center gap-6">
            <Link
              to="/about"
              className="px-8 py-4 bg-white text-teal-600 text-base font-semibold rounded-full hover:bg-gray-50 transition-all duration-300 hover:shadow-2xl whitespace-nowrap cursor-pointer"
            >
              詳しく見る
            </Link>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/regional-cooperation"
                className="px-8 py-3 bg-transparent border-2 border-white text-white text-base font-semibold rounded-lg hover:bg-white hover:text-teal-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                医療関係の方へ
              </Link>
              <Link
                to="/heart-failure"
                className="px-8 py-3 bg-transparent border-2 border-white text-white text-base font-semibold rounded-lg hover:bg-white hover:text-teal-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                患者さんへ
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
